import CodeFieldSection from './CodeFieldSection';
import CodeFieldSectionSimple from './CodeFieldSectionSimple';
import { CodeField } from '@scale/shared/types/params/textcollection';
import { useUnleashFeatureFlagWithLoading } from 'react-scale/hooks/useUnleashFeatureFlag';
import { CodeFieldAnnotation } from '@scale/shared/types/response/textcollection';

interface Props {
  field: CodeField;
  isCustomer?: boolean; // to control hidden test cases
  annotation: CodeFieldAnnotation;
  setAnnotation: (annotation: CodeFieldAnnotation) => void;
  setSubmitError?: (field_id: string, error: string) => void;
  disabled?: boolean;
  projectId?: string;
  assignmentId?: string;
  userId?: string;
  useSimpleCodeField?: boolean;
}

const CodeFieldSectionWrapper: React.FC<Props> = props => {
  const overrideUseSimpleCodeFieldSection = useUnleashFeatureFlagWithLoading(
    'use-simple-code-field',
    { projectId: props.projectId },
    false,
  );
  const shouldUseSimpleCodeField =
    overrideUseSimpleCodeFieldSection.data || props.useSimpleCodeField;

  if (overrideUseSimpleCodeFieldSection.isLoading) {
    return <div>Loading...</div>;
  }

  if (shouldUseSimpleCodeField) {
    return <CodeFieldSectionSimple {...props} />;
  } else {
    return <CodeFieldSection {...props} />;
  }
};

export default CodeFieldSectionWrapper;
